import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';
import { CancelPendingPaymentsAnalyticsMessages } from './cancel-pending-payments-analytics.constants';
import { CANCEL_PENDING_PAYMENTS_ANALYTICS_ACTIONS } from './cancel-pending-payments-analytics.actions';
import { cancelPendingPaymentTransformer } from './cancel-pending-payments-analytics.transformers';

@Injectable({
  providedIn: 'root',
})
export class CancelPendingPaymentsAnalyticsService {
  constructor(private store: Store) {}

  trackCancelPayment(
    customerCount: Number,
    fileCount: Number,
    totalAmount: Number,
  ): void {
    const tracking: Tracking = {
      analytics: {
        data: {
          'capability': CancelPendingPaymentsAnalyticsMessages.capability,
          'event': CancelPendingPaymentsAnalyticsMessages.cancelPaymentEvent,
          'customerCount': customerCount,
          'file.fileCount': fileCount,
          'totalAmount': totalAmount,
        },
        transformFunc: cancelPendingPaymentTransformer,
      },
    };
    this.store.dispatch(
      CANCEL_PENDING_PAYMENTS_ANALYTICS_ACTIONS.trackCancelPayment({
        tracking,
      }),
    );
  }
}
